import React from 'react';
import { connect } from 'react-redux'
import '../login.css';
import Header from '../Components/Header/HeaderUnauthorized';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import Spinner from '../Components/Spinner';
import { resourceApi } from '../utils/fetchUtil';
import { hashHistory } from 'react-router';



class Connect extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            member: this.props.member,
            updatedPhone: false,
            updating: false,
            phone: '',
            newPhone: '',
            heading: "For the best user experience, please provide us with more ways to reach you."
        };
    }



    componentDidMount() {

        if(this.state.member === null){
            hashHistory.push('/')
        }

        if (window.localLabels) {
            var pageLabel = window.localLabels.filter((f) => {
                return (f.page === "reg-2");
            })

            if (pageLabel.length >= 0) {
                this.setState({
                    heading: pageLabel[0].label
                })
            }
        }

    }


    getWhiteLabelKey() {
        if (window.COMPANY_ID != undefined) {
            return window.COMPANY_ID;
        }
        else {
            return 0;
        }
    }

    handleChangePhone = (event, value) => {
        if (value.length != 10) {
            this.setState({ phoneError: true, phone: value })
        }
        else {
            this.setState({ phoneError: false, phone: value })
        }
    }

    handleSubmit = () => {
        if (this.state.phone.length == 10 && this.state.updating == false) {
            let config = {
                method: 'post',
                url: 'member/',
                data: { ClientUserID: this.state.member.ClientUserID, Phone: this.state.phone }
            };

            this.setState({updating: true})

            return resourceApi(config)
                .then(res => {
                    this.setState({updatedPhone:true})
                    this.setState({updating: false})
                })

                .catch(err => {
                    this.setState({updating: false})
                    console.log(err)
                })
        }

    }

    handleGetNotifications = () => {
        //we'll perform an action here based on enbironment and whether they have previously been promted.
    }

    handleNotNow = () => {
        hashHistory.push('/home');
    }


    render() {

        return (

            <div>
                {!this.state.member && (
                    <div>
                        <Spinner />
                    </div>
                )}
                {this.state.member && (
                    <div>
                        <Header>
                            <span className="white" >Connect With Us</span>
                        </Header>
                        <br />
                        <div className="container" >
                            <div style={{ textAlign: 'center' }}>
                                <p className="white truenoLight" style={{ fontSize: 15 }}>{this.state.heading}</p>
                                <div className="container" style={{ textAlign: 'left' }}>
                                    <p className={'white'} style={{ paddingBottom: 0, marginBottom: 0 }}>Mobile Number</p>
                                    <p className="white truenoLight" style={{ fontSize: 12, padding: 0, margin: 0 }}>Providing us with your phone number will allow us to reach out to you regarding your care.</p>
                                    <br />
                                        {!this.state.member.Phone && !this.state.updatedPhone && (
                                        <div>
                                            <TextField errorText={this.state.phoneError} type={'number'} value={this.state.phone} hintText="(123) 456-7890" onChange={this.handleChangePhone} fullWidth={true} inputStyle={{ color: "#fff" }} hintStyle={{ color: "#fff" }} />
                                            <FlatButton label="SUBMIT" default={true} fullWidth={true} style={{ border: '1px solid #FFF', color: "#fff", height: "50px" }} labelStyle={{ fontSize: '26px' }} onClick={this.handleSubmit} />
                                        </div>
                                        )}
                                        {this.state.member.Phone && !this.state.updatedPhone && (
                                        <div>
                                            <TextField errorText={this.state.phoneError} type={'number'} value={this.state.phone} hintText={this.state.member.Phone} onChange={this.handleChangePhone} fullWidth={true} inputStyle={{ color: "#fff" }} hintStyle={{ color: "#fff" }} />
                                            <FlatButton label="UPDATE" default={true} fullWidth={true} style={{ border: '1px solid #FFF', color: "#fff", height: "50px" }} labelStyle={{ fontSize: '26px' }} onClick={this.handleSubmit} />
                                        </div>
                                        )}
                                        {this.state.updatedPhone && (
                                        <div style={{ textAlign: 'center' }}>
                                            <br />
                                            <p className="white truenoLight" style={{ fontSize: 15 }}>Successful Update</p>
                                        </div>
                                        )}

                                    <br />
                                    <br />
                                    <p className={'white'} style={{ paddingBottom: 0, marginBottom: 0 }}>Enable Notifications</p>
                                    <p className="white truenoLight" style={{ fontSize: 12, padding: 0, margin: 0 }}>With notifications enabled, we will be able to alert you to responses from our Care Guides and deliver information regarding your care.</p>
                                    <br />
                                    <FlatButton label="GET NOTIFICATIONS" default={true} fullWidth={true} style={{ border: '1px solid #FFF', color: "#fff", height: "50px" }} labelStyle={{ fontSize: '26px' }} />
                                </div>
                                <br />
                                <FlatButton label="NOT NOW" default={true} fullWidth={true} style={{ border: '1px solid #FFF', color: "#fff", height: "50px" }} labelStyle={{ fontSize: '26px' }} onClick={this.handleNotNow} />

                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return (
        {
            member: state.thisApp.auth.member,
        }
    )
}


export default connect(
    mapStateToProps,
)(Connect)


// WEBPACK FOOTER //
// ./src/Pages/Connect.js